import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { API_URL } from "../../shared/constant";
import { toast } from 'react-toastify';
import { Watch } from "react-loader-spinner";
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import Crop from '../../shared/crop';


const TestimonialAdd = () => {
    const navigate = useNavigate();
    let { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    const [isError, setError] = useState(false);
    const [formData, setFormData] = useState(
        {
            client_name: '',
            review: '',
            image: '',
            image_url: '',
            client_address: ''
        });

    useEffect(() => {
        id && onEdit();
    }, [id])


const onSave = (e) => {
    if (
        formData.client_name &&
        formData.client_address
    ) {
        setError(false);
        setLoading(true);

        const pUrl = id ? API_URL.TESTIMONIAL_UPDATE : API_URL.TESTIMONIAL_SAVE;

        if (id) {
            formData.id = id; 
        }

        axios.post(pUrl, formData)
            .then((res) => {
                if (res.data.status === 1) {
                    let message = id
                        ? "Testimonial Updated Successfully."
                        : "Testimonial Created Successfully.";
                    toast.success(message, { autoClose: 3000, position: "top-right" });
                    navigate("/settings/testimonial");
                } else {
                    toast.error(res.data.data?.id?.[0] || "Something went wrong.");
                }
            })
            .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
};

        const isRequiredField = (key) => {
            return isError && !formData[key];
        };

        const onEdit = () => {
            axios.post(API_URL.TESTIMONIAL_GET, { id: id }).then((response) => {
                if (response.data.status === 1) {
                    const data = response.data.data;
                    setFormData({
                        client_name: data.client_name || '',
                        review: data.review || '',
                        image_url: data.image_url || '',
                        client_address: data.client_address || '',
                        image: '',
                    });
                    setImagePreview(data.image_url);
                }
            })
        };


        return (
            <div>
                <div className="row">
                    <div className="col-6">
                        <h1>{id ? "Edit" : "Add"} Testimonial</h1>
                    </div>
                    <div className="col-6">
                        <div className="d-flex align-items-center  justify-content-end">
                            <Link to={"/settings/testimonial"} className="btn btn-secondary">
                                <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                            </Link>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={(event) => event.preventDefault()}>
                                    <div className="row">
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <label>Client Name <span className="required-star">*</span></label>
                                                <input
                                                    className={
                                                        isRequiredField("client_name")
                                                            ? "form-control required"
                                                            : "form-control"
                                                    }
                                                    name='client_name'
                                                    type="text"
                                                    value={formData.client_name}
                                                    onChange={(event) => {
                                                        setFormData({ ...formData, client_name: event.target.value })
                                                    }}
                                                ></input>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <label>Address <span className="required-star">*</span></label>
                                                <input
                                                    className={
                                                        isRequiredField("client_address")
                                                            ? "form-control required"
                                                            : "form-control"
                                                    }
                                                    name='client_address'
                                                    type="text"
                                                    value={formData.client_address}
                                                    onChange={(event) => {
                                                        setFormData({ ...formData, client_address: event.target.value })
                                                    }}></input>
                                            </div>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <label>Review</label>
                                                <input
                                                    className='form-control'
                                                    name='review'
                                                    type="text"
                                                    value={formData.review}
                                                    onChange={(event) => {
                                                        setFormData({ ...formData, review: event.target.value })
                                                    }}></input>
                                            </div>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <label>Image</label>
                                                <Crop imagePreview={imagePreview} cropShape='round' guid={''}
                                                    onChangeCropper={async ({ fileCropped, fileCroppedBase64 }) => {
                                                        setFormData({ ...formData, image: fileCroppedBase64 })
                                                        setImagePreview(fileCroppedBase64);
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group text-right">
                                            <button
                                                type="submit"
                                                onClick={onSave}
                                                // disabled={loading}
                                                className="btn btn-primary"
                                            >
                                                {loading ? (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <Watch color={"white"} height={20} width={20} />
                                                    </div>
                                                ) : (
                                                    "Save"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
    export default TestimonialAdd;